import {
  Component,
  h,
  Prop,
  Host,
  ComponentInterface,
  Event,
  EventEmitter,
  Element,
} from "@stencil/core";

@Component({
  tag: "signet-radio",
  styleUrl: "signet-radio-group.scss",
})
export class SignetRadio implements ComponentInterface {
  @Element() el!: HTMLElement;

  radioButtonId = `radio_${radioButtonIds++}`;

  @Prop() label: string;
  @Prop() checked: boolean;
  @Prop() inline = false;
  @Prop() name: string;
  @Prop() value: string;
  @Prop() disabled = false;

  @Event() selected!: EventEmitter;

  private handleClick() {
    this.selected.emit(this.label);

    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: this.value
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: this.value
    }));
  }

  render() {
    const classes = {
      "signet-radio": true,
      inline: this.inline,
    };
    return (
      <Host class={classes}>
        <div class="input-wrapper">
          <input
            class="radio-button"
            id={this.radioButtonId}
            type="radio"
            name={this.name}
            checked={this.checked}
            disabled={this.disabled}
            value={this.value}
            onChange={() => this.handleClick()}
          />
          <label class="radio-label" htmlFor={this.radioButtonId}>
            {this.label}
          </label>
        </div>
      </Host>
    );
  }
}

let radioButtonIds = 0;
